import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUiTableModule } from '@snelstart/ui-table';
import { FeatureTaxAllowanceListComponent } from './tax-allowance-list/feature-tax-allowance-list.component';
import {SharedUiButtonModule} from "@snelstart/ui-button";
import {FeatureTaxAllowanceDetailsModule} from "@snelstart-ventures/fiscaal/feature-tax-allowance-details";

@NgModule({
  imports: [CommonModule, SharedUiTableModule, SharedUiButtonModule, FeatureTaxAllowanceDetailsModule, FeatureTaxAllowanceListComponent],
  declarations: [],
  exports: [FeatureTaxAllowanceListComponent],
})
export class FeatureTaxAllowanceListModule {}
